import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { Team, TeamDichotomiesContent, TeamMember, UserDetails } from '../../app.models';
import { AppService } from '../../app.service';
import { ApplicationInsightsService } from '../../application-insights.service';
import { ContentService } from '../../services/content.service';
import { IntroductionService } from '../../services/introduction.service';

@Component({
  selector: 'app-team-dichotomies',
  templateUrl: './team-dichotomies.component.html',
  styleUrls: ['./team-dichotomies.component.scss'],
  standalone: true,
  imports: [SafeHtmlPipe, CommonModule],
})
export class TeamDichotomiesComponent implements OnInit {
  swooshText = '';
  swooshRoute = '/team';
  isApiDataLoaded: boolean = false;
  username: string = '';
  firstName: string = '';
  lastName: string = '';
  emailAddress: string = '';
  mbtiType: string = '';
  introduction: string = '';
  teamInfo: Team;
  userInfo: Observable<UserDetails>;
  Http: HttpClient;
  contentObject: TeamDichotomiesContent[];
  readonly twoColumnCount: number = 4;
  readonly showMoreCount: number = 8;

  constructor(
    private appService: AppService,
    http: HttpClient,
    private route: ActivatedRoute,
    private introductionService: IntroductionService,
    private contentService: ContentService,
    private applicationInsightsService: ApplicationInsightsService,
  ) {
    this.Http = http;
  }

  getContent(name: string): TeamDichotomiesContent {
    try {
      var result = this.contentObject.filter((obj) => {
        return obj.name.toLowerCase() === name.toLowerCase();
      });

      return result[0];
    } catch (exception) {
      console.error(exception);
      this.applicationInsightsService.logException(exception);
      return null;
    }
  }

  getMembersByDichotomy(matchingPattern: string): Array<TeamMember> {
    var filteredTeamMembers = this.teamInfo.teamMembers.filter(
      (member) => member.mbtiType !== null && member.mbtiType.toLowerCase().match(matchingPattern),
    );
    return filteredTeamMembers;
  }

  isMe(member: TeamMember): boolean {
    return member.emailAddress.toLowerCase() === this.emailAddress.toLowerCase();
  }

  ngOnInit() {
    this.mbtiType = this.appService.mbtiType;
    this.firstName = this.appService.firstName;
    this.lastName = this.appService.lastName;
    this.emailAddress = this.appService.emailAddress;
    this.introduction = this.introductionService.getContent('Dichotomies');

    this.teamInfo = this.appService.getTeamInfo();

    var me = this.teamInfo.teamMembers.filter((member) => this.emailAddress.toLowerCase() === member.emailAddress.toLowerCase())[0];
    this.teamInfo.teamMembers = this.teamInfo.teamMembers.filter((member) => this.emailAddress.toLowerCase() != member.emailAddress.toLowerCase());
    if (me) {
      this.teamInfo.teamMembers.unshift(me);
    }

    this.userInfo = this.appService.getUserDetails();
    this.route.queryParams.subscribe(() => {});

    this.contentService.getContent<TeamDichotomiesContent[]>('TeamsPreferencePairs').subscribe({
      next: (data) => {
        this.contentObject = data;
        this.isApiDataLoaded = true;
      },
      error: () => {
        // no need to log: handled in service, but if you want to do something, you can with this block
      },
    });
  }
}
